import { render } from "./attendee.list.vue?vue&type=template&id=6fa539f6"
import script from "./attendee.list.vue?vue&type=script&lang=js"
export * from "./attendee.list.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__